


































































































import { Component, Provide, Vue } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import Constants from '@/constants';

@Component({
  props: ['organizationId'],
})
export default class ExportModal extends Vue {
  @Provide()
  useGlobalFormatExport: boolean = false;
  isExportProcessed: boolean = false;
  isExportFail: boolean = false;
  lrOrganizations: any = [];
  isNotEncrypted: boolean = false;
  request: any = null;
  groupSize: number = 6;

  created() {
    axios.get('/Dictionary/GetLrOrganizationCodes')
         .then((response) => {
             for(let i = 0; i < response.data.length; i++) {
                response.data[i]['isChecked'] = true;
             }
             this.lrOrganizations = response.data;
         })
  }

  showModal() {    
    this.isExportProcessed = false;
    this.isExportFail = false;
    this.$root.$emit('bv::show::modal', 'export-wmda-donors-modal');
    //this.exportDonors();
  }

  hideModal() {
    if (this.request) {
      this.request.cancel('user_cancel');
    }

    this.$root.$emit('bv::hide::modal', 'export-wmda-donors-modal');
    this.$emit('closeModal');
  }

  get groupedOrganizations() {
    let result: any = [];
    for(var i = 0; i < this.lrOrganizations.length; i += this.groupSize) {
      result.push(this.lrOrganizations.slice(i, i + this.groupSize));
    }
    return result;
  }

  get isAllChecked() {
    let result = true;

    if (this.lrOrganizations) {
      this.lrOrganizations.forEach((r: any) => (result = result && r.isChecked));
    }

    return result;
  }

  set isAllChecked(value) {
    if (value) {
      this.lrOrganizations.forEach((r: any) => (r.isChecked = true));
    } else {
      if (this.isAllChecked) {
        this.lrOrganizations.forEach((r: any) => (r.isChecked = false));
      }
    }
  }

  get exportIds() {
    return Array.prototype.map.call(this.lrOrganizations.filter(function(f : any) { return f.isChecked; }), function(item) { return item.key; }).join(",");
  }

  get exportUrl() {
    return Constants.baseUrl + '/donors/ExportWmda?ids=' + this.exportIds + '&isNotEncrypted=' + this.isNotEncrypted;
  }

  exportDonors() {
    const CancelToken = axios.CancelToken;

    this.request = CancelToken.source();
    this.isExportProcessed = true;
    this.isExportFail = false;

    axios({
      url: this.exportUrl,
      method: 'GET',
      responseType: 'blob',
      cancelToken: this.request.token,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        const fileName = `WMDA_${moment().format('YYYYMMDD')}.` + (this.isNotEncrypted ? 'xml' : 'gpg');

        this.isExportProcessed = false;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.hideModal();
        //@ts-ignore
        this.$swal({ title: this.$t('Экспортировано') + ` ${response.headers['donorscount']} ` + this.$t('записей'), icon: "success" });
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          this.isExportFail = true;
          this.isExportProcessed = false;
        }
      });
  }
}
